import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { UploadCloud } from "lucide-react";

import { API } from "@/lib/api";
export default function AdminUploader({ pin, onUploaded }) {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("geral");
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const onFilesChange = (e) => setFiles(Array.from(e.target.files || []));

  const onUpload = async (e) => {
    e.preventDefault();
    if (!files.length) {
      toast.warning("Selecione ao menos uma imagem");
      return;
    }
    setUploading(true);
    let okCount = 0;
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const params = new URLSearchParams();
        params.set("pin", pin);
        if (title) params.set("title", title);
        if (category) params.set("category", category);
        await axios.post(`${API}/gallery/upload?${params.toString()}`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        okCount++;
      } catch (err) {
        const msg = err?.response?.data?.detail || err.message;
        toast.error(`Falha em ${f.name}`, { description: String(msg) });
      }
    }
    setUploading(false);
    setFiles([]);
    setTitle("");
    if (okCount) {
      toast.success(`${okCount} foto(s) enviada(s) com sucesso`);
      onUploaded?.();
    }
  };

  return (
    <form
      onSubmit={onUpload}
      className="lg:col-span-5 bg-white border border-[var(--mn-line)] rounded-[4px] p-7"
      data-testid="admin-upload-form"
    >
      <span className="mn-eyebrow">Enviar fotos</span>
      <h2 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] mt-3">
        Adicione fotos à galeria
      </h2>
      <p className="text-sm text-[var(--mn-dark)] mt-2 mb-6 leading-relaxed">
        JPG, PNG ou WEBP até 8MB. Você pode selecionar várias imagens ao mesmo tempo.
      </p>

      <label className="mn-label" htmlFor="ad-title">Título (opcional)</label>
      <input
        id="ad-title"
        type="text"
        className="mn-input"
        placeholder="Ex.: Sacola de Algodão campanha verão"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        data-testid="admin-title"
      />

      <label className="mn-label mt-4" htmlFor="ad-cat">Categoria</label>
      <select
        id="ad-cat"
        className="mn-input"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        data-testid="admin-category"
      >
        <option value="ecobag">Sacola de Algodão</option>
        <option value="sacola-tnt">Sacola TNT</option>
        <option value="squeeze">Squeeze</option>
        <option value="toalha">Toalha</option>
        <option value="brindes">Brindes Corporativos</option>
        <option value="evento">Evento / Aplicação</option>
        <option value="geral">Geral</option>
      </select>

      <label className="mn-label mt-4">Arquivos*</label>
      <label
        htmlFor="ad-files"
        className="border-2 border-dashed border-[var(--mn-line)] hover:border-[var(--mn-gold)] transition-colors rounded-[4px] p-8 text-center cursor-pointer flex flex-col items-center gap-3"
        data-testid="admin-dropzone"
      >
        <UploadCloud size={28} className="text-[var(--mn-gold)]" />
        <span className="text-sm font-medium text-[var(--mn-black)]">
          Arraste fotos aqui ou clique para escolher
        </span>
        <span className="text-xs text-[var(--mn-dark)]">
          {files.length > 0 ? `${files.length} arquivo(s) selecionado(s)` : "Aceita múltiplas imagens"}
        </span>
        <input
          id="ad-files"
          type="file"
          accept="image/*"
          multiple
          onChange={onFilesChange}
          className="hidden"
          data-testid="admin-file-input"
        />
      </label>

      {files.length > 0 && (
        <ul className="mt-4 space-y-1 text-xs text-[var(--mn-dark)] max-h-32 overflow-auto">
          {files.map((f) => (
            <li key={`${f.name}-${f.size}-${f.lastModified}`} className="flex justify-between items-center border-b border-[var(--mn-line)] py-1">
              <span className="truncate">{f.name}</span>
              <span>{(f.size / 1024).toFixed(0)} KB</span>
            </li>
          ))}
        </ul>
      )}

      <button
        type="submit"
        disabled={uploading || files.length === 0}
        className="btn-mn-primary w-full mt-6 disabled:opacity-60"
        data-testid="admin-upload-submit"
      >
        {uploading ? (
          <><i className="fa-solid fa-circle-notch fa-spin" /> Enviando…</>
        ) : (
          <><UploadCloud size={16} /> Enviar para a galeria</>
        )}
      </button>
    </form>
  );
}
